import { assign } from 'xstate';

interface InquiryContext {
  inquiryRetryCount: number;
}

export const incrementInquiryRetryCount = assign<InquiryContext>({
  inquiryRetryCount: context => context.inquiryRetryCount + 1,
});
